// util.js

export function arraysAreEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }

  for (let i = 0; i < array1.length; i++) {
    const left = array1[i];
    const right = array2[i];

    // Try numeric comparison with tolerance if both are numeric-like
    const leftNum = typeof left === 'number' ? left : (typeof left === 'string' ? Number(left) : NaN);
    const rightNum = typeof right === 'number' ? right : (typeof right === 'string' ? Number(right) : NaN);

    if (Number.isFinite(leftNum) && Number.isFinite(rightNum)) {
      // Compare up to 2 decimal places to tolerate values like 1690.291666... vs 1690.29
      const leftRounded = Math.round(leftNum * 100) / 100;
      const rightRounded = Math.round(rightNum * 100) / 100;
      if (leftRounded !== rightRounded) {
        // Additional safety: absolute tolerance check
        if (Math.abs(leftNum - rightNum) > 0.005) {
          return false;
        }
      }
    } else {
      // Fallback to strict equality for non-numeric values
      if (left !== right) {
        return false;
      }
    }
  }

  return true;
}
